.track {
  display: flex;
  padding: 3px;
  gap: 3px;
  background: var(--panel2);
  border-radius: var(--r-control);
}

.item {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: var(--target);
  padding: 0 var(--s2);
  border: 0;
  border-radius: var(--r-control);
  background: transparent;
  color: var(--ink);
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 650;
  overflow-wrap: break-word;
}

.item:active:not(.on) {
  background: var(--line);
}

/* Selected item is filled --ink (DESIGN_SYSTEM §3) */
.on {
  background: var(--ink);
  color: var(--panel);
}
